"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _server = require("@telus-uds/components-base/server");
var _logger = require("../utils/logger");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _server.selectSystemProps)([_server.htmlAttrs]);
const Image = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    src,
    width,
    height,
    alt,
    rounded,
    loading = 'eager',
    tokens,
    theme,
    variant,
    ...rest
  } = _ref;
  let {
    borderRadius
  } = theme;
  const isCircle = rounded === 'circle';
  const isCorners = rounded === 'corners';
  const isSquare = width === height;
  if (isCircle && !isSquare) {
    (0, _logger.warn)('Image', 'rounded="circle" is not supported for non-square images. Please provide a square image, otherwise the resulting shape will not be a circle.');
  }
  if (isCircle) {
    borderRadius = '50%';
  } else if (isCorners) {
    borderRadius = '4px';
  }
  const style = {
    borderRadius,
    height: height ?? 'auto',
    maxWidth: '100%'
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    ...selectProps(rest),
    style: style,
    src: src,
    width: width,
    height: height,
    alt: alt,
    loading: loading,
    ref: ref
  });
});
Image.displayName = 'Image';
Image.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * The src attribute for the HTML img element.
   */

  src: _propTypes.default.string.isRequired,
  /**
   * The alt attribute for the HTML img element. Setting this attribute to an empty string (alt="") indicates that this image is not a key part of the content, and that non-visual browsers may omit it from rendering.
   */
  alt: _propTypes.default.string.isRequired,
  /**
   * The image's width.
   */
  width: _propTypes.default.number.isRequired,
  /**
   * The image's height.
   */
  height: _propTypes.default.number,
  /**
   * Loading strategy.
   * @default 'eager'
   * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-loading
   */
  loading: _propTypes.default.oneOf(['eager', 'lazy']),
  /**
   * Make image render as a circle or with rounded corners.
   */
  rounded: _propTypes.default.oneOf(['circle', 'corners']),
  tokens: (0, _server.getTokensPropType)('Image')
};
Image.displayName = 'Image';
var _default = exports.default = Image;